import './../vendors/jquery.cookieBar';

let bar = document.getElementById('cookie-bar');

if(bar){
    $(bar).cookieBar({
        closeButton : '#cookie-bar-btn',
        //secure: true, 
        hideOnClose: false,
    });
    $(bar).on('cookieBar-close', function() { 
        bar.classList.add('closed');
    });
}



// WEBPACK FOOTER //
// ./scripts/modules/funds-cookie-bar.js